import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './Banner.scss';
function Banner({ banner }) {
    const isMobile = useSelector(({ ui }) => ui.isMobile);
    const bannerCSSVariables = {
        '--background-color': banner.colors.backgroundColor,
        '--text-color': banner.colors.textColor,
        '--title-font': banner.fontFamily == 'serif' ? '"Calluna", serif' : '"Agipo", sans-serif',
        '--font-weight': banner.fontFamily == 'serif' ? 400 : 700,
        '--text-padding-top': banner.badge ? '64px' : '40px',
    };
    return (React.createElement(NavLink, { to: banner.targetUrl, className: "banner" },
        React.createElement("div", { style: bannerCSSVariables },
            React.createElement("div", { className: "banner__image-wrapper" },
                React.createElement("img", { className: "banner__image-wrapper__main-image", src: isMobile
                        ? banner.backgroundImage.mobile
                        : banner.backgroundImage.desktop, alt: "" }),
                banner.overlayImage && (React.createElement("img", { className: "banner__image-wrapper__overlay-image", src: banner.overlayImage, alt: "" })),
                banner.badge && (React.createElement("img", { className: "banner__image-wrapper__badge", src: banner.badge.image, alt: "" }))),
            React.createElement("div", { className: "banner__text-wrapper" },
                React.createElement("h2", { className: "banner__text-wrapper__title" }, banner.title),
                React.createElement("p", { className: "banner__text-wrapper__lead-text" }, banner.leadText)))));
}
export default Banner;
